import { useEffect } from "react";
import { createPortal } from "react-dom";
import VideoEmbedPlayer from "../../components/Atomos/VideoEmbedPlayer/VideoEmbedPlayer";
import { canPlayTutorialVideo } from "../../utils/videoEmbeds";

type HelpCenterTutorialVideoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  videoUrl?: string;
};

export default function HelpCenterTutorialVideoModal({
  isOpen,
  onClose,
  videoUrl,
}: HelpCenterTutorialVideoModalProps) {
  const canPlay = videoUrl ? canPlayTutorialVideo(videoUrl) : false;

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !canPlay) {
    return null;
  }

  return createPortal(
    <div
      className="help-center-tutorial-video-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Watch the Tutorial"
    >
      <div
        className="help-center-tutorial-video-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <VideoEmbedPlayer
          key={videoUrl}
          videoUrl={videoUrl ?? ""}
          title="Watch the Tutorial"
          autoplay
          disableDownload
        />
      </div>
      <p className="help-center-tutorial-video-dismiss-hint">
        Press Esc or click outside to close
      </p>
    </div>,
    document.body,
  );
}
